module.exports = __webpack_public_path__ + "static/media/filter.b14ef09b.svg";